export const blockIconsCommunicationAlternateEmail = (
	<span className='material-symbols-outlined'>alternate_email</span>
);
